import { render, staticRenderFns } from "./DiceButton.vue?vue&type=template&id=661ef485&scoped=true&"
import script from "./DiceButton.vue?vue&type=script&lang=js&"
export * from "./DiceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ef485",
  null
  
)

export default component.exports